export interface BrandInfo {
  name: string;
  fullName: string;
  slogan: string;
  description: string;
  founded: string;
  mission: string;
  vision: string;
  values: { title: string; description: string }[];
  milestones: { year: string; event: string }[];
  contact: {
    email: string;
    phone: string;
    address: string;
    workingHours: string;
  };
}

export const brandInfo: BrandInfo = {
  name: "JM官方入口",
  fullName: "JM网页版官方服务平台",
  slogan: "一键直达，安全稳定的JM网页版官方入口",
  description: "JM网页版官方服务平台致力于为广大用户提供最新、最安全的JM网页版官方入口地址。我们秉承用户至上的理念，持续更新和维护入口信息，确保每一位用户都能通过官方渠道安全稳定地访问JM平台。",
  founded: "2020年",
  mission: "让每一位用户都能便捷、安全地访问JM网页版平台，享受流畅的在线服务体验",
  vision: "成为用户首选的JM网页版入口导航平台，建立安全可靠的访问生态",
  values: [
    { title: "安全第一", description: "始终将用户账号安全和数据隐私放在首位，严格筛选和验证每一个入口地址" },
    { title: "用户至上", description: "以用户需求为导向，持续优化服务体验，及时响应用户反馈" },
    { title: "稳定可靠", description: "保证入口地址的高可用性，确保用户可以随时稳定访问JM平台" },
    { title: "信息透明", description: "及时公开更新日志和变更信息，让用户了解最新的入口动态" },
  ],
  milestones: [
    { year: "2020年", event: "JM平台正式上线，开始提供网页版服务" },
    { year: "2021年", event: "网页版用户突破100万，持续优化访问体验" },
    { year: "2022年", event: "推出CDN加速服务，全球访问延迟降低50%" },
    { year: "2023年", event: "完成安全体系全面升级，通过国际安全认证" },
    { year: "2024年", event: "上线智能路由功能，自动匹配最优访问节点" },
    { year: "2025年", event: "网页版月活跃用户突破500万" },
    { year: "2026年", event: "推出全新UI界面，夜间模式等多项新功能上线" },
  ],
  contact: {
    email: "support@jm-official.com",
    phone: "400-XXX-XXXX",
    address: "中国 · 线上服务",
    workingHours: "周一至周日 9:00 - 21:00",
  },
};

export interface Review {
  id: string;
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
  source: string;
}

export const reviews: Review[] = [
  {
    id: "rev-1",
    name: "张先生",
    avatar: "",
    rating: 5,
    content: "JM网页版真的很方便，不用下载APP就能直接使用，而且入口地址一直很稳定。收藏了这个页面之后每次都能顺利访问，强烈推荐！",
    date: "2026-08-06",
    source: "用户评价",
  },
  {
    id: "rev-2",
    name: "李女士",
    avatar: "",
    rating: 5,
    content: "用了JM网页版快两年了，功能跟APP完全一样，而且不占手机内存。特别是教程很详细，新手也能快速上手。",
    date: "2026-08-04",
    source: "用户评价",
  },
  {
    id: "rev-3",
    name: "王同学",
    avatar: "",
    rating: 5,
    content: "作为学生党，手机内存永远不够用。JM网页版完美解决了这个问题，打开浏览器就能用，学习资料随时查看，太方便了！",
    date: "2026-08-02",
    source: "用户评价",
  },
  {
    id: "rev-4",
    name: "刘先生",
    avatar: "",
    rating: 4,
    content: "整体体验很不错，偶尔遇到访问慢的问题，按照教程清理缓存后就好了。希望继续保持稳定，会一直用下去的。",
    date: "2026-07-30",
    source: "用户评价",
  },
  {
    id: "rev-5",
    name: "陈女士",
    avatar: "",
    rating: 5,
    content: "安全指南写得特别详细，让我这个不太懂技术的人也能保护好自己的账号。官方入口果然靠谱，比那些来路不明的链接安全多了。",
    date: "2026-07-28",
    source: "用户评价",
  },
];

export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    id: "faq-1",
    question: "JM网页版官网入口是什么？",
    answer: "JM网页版官网入口是JM平台官方提供的浏览器访问通道，用户无需下载APP即可通过浏览器直接访问JM平台的全部功能，是安全、便捷的官方访问方式。",
  },
  {
    id: "faq-2",
    question: "如何找到JM最新入口地址？",
    answer: "建议将本页面加入浏览器收藏夹，我们会持续更新JM最新入口地址。您也可以关注JM官方公告获取入口更新信息。请勿使用不明来源的第三方链接。",
  },
  {
    id: "faq-3",
    question: "JM网页版和APP版数据互通吗？",
    answer: "完全互通。JM网页版与APP版使用同一账号体系，所有数据实时同步。您在网页版上的任何操作都会即时同步到APP端，反之亦然。",
  },
  {
    id: "faq-4",
    question: "JM网页版登录需要什么条件？",
    answer: "您只需要一个已注册的JM账号、稳定的网络连接以及现代浏览器（推荐Chrome、Edge、Safari或Firefox的最新版本）即可登录使用。",
  },
  {
    id: "faq-5",
    question: "JM网页版安全吗？会不会泄露个人信息？",
    answer: "通过JM官方入口访问的网页版是绝对安全的。平台采用银行级SSL加密技术保护数据传输，严格遵循隐私保护法规，不会泄露用户个人信息。",
  },
  {
    id: "faq-6",
    question: "为什么有时候JM网页版打不开？",
    answer: "可能原因包括：网络波动、浏览器缓存问题、DNS解析异常或服务器临时维护。建议清除浏览器缓存、切换网络或稍后重试。如持续无法访问，请联系客服。",
  },
  {
    id: "faq-7",
    question: "JM网页版支持哪些浏览器？",
    answer: "JM网页版支持所有主流现代浏览器，包括Google Chrome、Microsoft Edge、Safari、Firefox等。建议使用最新版本以获得最佳体验。",
  },
  {
    id: "faq-8",
    question: "使用JM网页版需要付费吗？",
    answer: "JM网页版访问本身是免费的。具体功能使用可能根据JM平台的会员政策有所不同，请参考JM官方的资费说明。",
  },
];